module.exports = __webpack_public_path__ + "img/手机@2x.5b7abb78.png";